<template>
  <b-container>
    <b-row align-h="center" v-if="!added">
      <b-col cols=6>
        <h2>Add New Scoring Event</h2>
        <survey-run-selection :new-only="true" @update:surveyRun="saved"/>
      </b-col>
    </b-row>
    <b-row align-h="center" v-if="added">
      <b-col>
        <h2>Scoring Event Saved</h2>
        {{ surveyRun.programme.name }} - {{ surveyRun.customer.name }} {{ surveyRun.period }} {{ surveyRun.year }}
      </b-col>
    </b-row>
    <b-row align-h="center" v-if="added" class="pt-4">
      <b-col>
        <b-button @click="added = false" variant="primary">Add another</b-button>
      </b-col>
      <b-col>
        <b-button @click="addSurveyData" variant="primary">Add Survey Data</b-button>
      </b-col>
    </b-row>
  </b-container>
  

</template>
<script>
// @ is an alias to /src
import SurveyRunSelection from "@/components/SurveyRunSelection.vue";

export default {
  name: "NewScoringEvent",
  components: {
    SurveyRunSelection
  },
  data() {
    return {
      surveyRun: null,
      added: false
    };
  },
  methods: {
    saved(newSurveyRun) {
      this.surveyRun = newSurveyRun.surveyRun;
      this.added = true;

    },
    addSurveyData() {
      this.$router.push({
        path: '/wizard',
        query: {
          scoringEventId: this.surveyRun.id
        }
      });
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/NewScoringEvent.vue